import { Document20Regular, PersonVoice20Regular } from '@/components/Icon'
import ActionButtonRow from './ActionButtonRow'
import styles from './HomePrimaryActions.module.scss'

/**
 * @param {{
 *   onDocuments?: () => void,
 *   onDoVoice?: () => void,
 *   documentsActive?: boolean,
 *   doVoiceActive?: boolean,
 * }} props
 */
export default function HomePrimaryActions({
  onDocuments,
  onDoVoice,
  documentsActive = false,
  doVoiceActive = false,
}) {
  return (
    <div className={styles.group}>
      {/* New Chat is not listed here: it floats in the main panel header on
       * every page, so a second copy in the rail would be a duplicate control
       * with a different resting position. */}
      <ActionButtonRow
        Icon={Document20Regular}
        label="Documents"
        onClick={onDocuments}
        active={Boolean(documentsActive)}
      />
      <ActionButtonRow
        Icon={PersonVoice20Regular}
        label="DO Voice"
        onClick={onDoVoice}
        active={Boolean(doVoiceActive)}
      />
    </div>
  )
}
